import React from 'react';
import { heroImages } from '../mock';
import { Milk, Sparkles, Award, ShieldCheck } from 'lucide-react';

const Quality = () => {
  return (
    <div className="min-h-screen bg-white pt-20">
      {/* Header Section */}
      <section className="relative py-20 bg-gradient-to-br from-emerald-50 via-white to-sky-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Lezzetin Kaynağı: Doğallık ve Kalite
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Her ürünümüz, doğal malzemeler ve titiz kalite kontrolü ile üretilir. 
Tazeliğin kaynağından sofranıza ulaşan lezzet yolculuğunu keşfedin.
          </p>
        </div>
      </section>

      {/* Dairy Products Process */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Image */}
            <div className="order-2 md:order-1">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://images.unsplash.com/photo-1628088062854-d1870b4553da"
                  alt="Süt üretimi"
                  className="w-full h-[500px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
              </div>
            </div>

            {/* Content */}
            <div className="order-1 md:order-2">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-100 rounded-full mb-6">
                <Milk className="h-8 w-8 text-[#216DB8]" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Süt Ürünleri: Tazelik ve Sağlık
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Pekala ayran ve yoğurt, en taze ve kaliteli sütlerden üretilir. 
Her sabah toplanan sütler, hijyenik koşullarda işlenerek aynı gün ürüne dönüştürülür.
              </p>
              <div className="space-y-4">
                <div className="flex items-start">
                  <ShieldCheck className="h-6 w-6 text-[#216DB8] mr-3 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Okul Gıdası Onaylı</h3>
                    <p className="text-gray-600 text-sm">
                      Tüm süt ürünlerimiz okul gıdası sertifikasına sahiptir. 
Çocuklarınız için güvenle seçebilirsiniz.
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Award className="h-6 w-6 text-[#216DB8] mr-3 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Kalite Güvencesi</h3>
                    <p className="text-gray-600 text-sm">
                      Modern tesislerimizde, uluslararası kalite standartlarına uygun üretim yapıyoruz.
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Sparkles className="h-6 w-6 text-[#216DB8] mr-3 flex-shrink-0 mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-1">Doğal İçerikler</h3>
                    <p className="text-gray-600 text-sm">
                      Katkı maddesi, koruyucu ve yapay tatlandırıcı kullanmıyoruz. 
Sadece doğal malzemeler.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Beverages Process */}
      <section className="py-20 bg-gradient-to-br from-amber-50 via-white to-emerald-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Content */}
            <div>
              <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full mb-6">
                <Sparkles className="h-8 w-8 text-amber-600" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                Taze İçecekler: Aromalı İçecekler
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                Pekala limonata ve vişne aromalı içecekleri, ev yapımı lezzette üretilir. 
                Modern hijyen standartları ile kaliteli içecekler.
              </p>
              <div className="space-y-4">
                <div className="bg-white rounded-xl p-4 shadow-md">
                  <h3 className="font-semibold text-gray-900 mb-2">Limon Aromalı İçecek</h3>
                  <p className="text-gray-600 text-sm">
                    Limonatamız, limon aroması ile ferahlatıcı bir lezzet sunar.
                  </p>
                </div>
                <div className="bg-white rounded-xl p-4 shadow-md">
                  <h3 className="font-semibold text-gray-900 mb-2">Vişne Aromalı İçecek</h3>
                  <p className="text-gray-600 text-sm">
                    Vişne içeceğimiz, vişne aroması ile hazırlanır ve ferahlatıcı bir tat sunar.
                  </p>
                </div>
                <div className="bg-white rounded-xl p-4 shadow-md">
                  <h3 className="font-semibold text-gray-900 mb-2">Geleneksel Şalgam
                  </h3>
                  <p className="text-gray-600 text-sm">
                    Şalgam suyumuz, geleneksel tariflerle hazırlanır. Acılı ve ferahlatıcı.
                  </p>
                </div>
              </div>
            </div>

            {/* Image */}
            <div>
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src={heroImages.orchard}
                  alt="Meyve bahçesi"
                  className="w-full h-[500px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quality Promise */}
      <section className="relative py-32 overflow-hidden">
        <div 
          className="absolute inset-0 z-0"
          style={{
            backgroundImage: `url(${heroImages.quality2})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-green-900/90" />
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Kalite Taahhüdümüz
          </h2>
          <p className="text-xl text-gray-200 leading-relaxed">
            Pekala olarak, her ürünümüzde doğallık ve kaliteyi ön planda tutuyoruz. 
En taze malzemeleri seçiyor, modern tesislerimizde hijyenik koşullarda üretiyoruz. 
Sofranıza ulaşan her ürün, titiz kalite kontrol süreçlerinden geçiyor. 
Çünkü siz ve aileniz için en iyisini hak ediyorsunuz.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Quality;
